import React, { useState, useEffect } from "react";
import tw from "tailwind-styled-components";
import { Link, useParams, useNavigate } from "react-router-dom";
import Images from "../../Images";
import { useMutation, useQuery } from "react-query";
import axios from "axios";
import Loading from "../../Components/Loading";
import Table from "../../Components/Applications/MyAssociationTable";
import PaymentModal from "../../Components/Applications/PaymentModal";
import LCPaymentModal from "../../Components/Applications/PaymentModal";
import Navbar from "../../Components/Navbar";
import Config from "../../Config";
import moment from "moment";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";
import { useTranslation } from "react-i18next";
import {
  Page,
  BoxContainer,
  BoxTitle,
  Underline,
  ErrorText,
} from "../../Components/Styles/PageStyles";
import {
  FieldWrapper,
  InputGroup,
  Label,
  SmallBtn,
} from "../../Components/Styles/InputStyles";
import NotFoundModel from "../../Components/NotFoundModel";
import DeleteModel from "../../Components/Campaigns/DeleteModel";
import { useSelector } from "react-redux";
import { ForUs } from "../../Config";
import EditDeviceModel from "../../Components/Campaigns/EditDeviceModel";
import SingleEntry from "../../Components/Campaigns/SingleEntry";
import { MdAdd } from "react-icons/md";
import { HiUpload } from "react-icons/hi";
import { toast } from "react-toastify";
import ViewModel from "../../Components/Applications/ViewModel";
import { Field, Form, Formik } from "formik";
import ChangeOfArticleTable from "../../Components/Services/ChangeOfArticleTable";
import ChangeOfNameTable from "../../Components/Services/ChangeOfNameTable";
import ChangeOfCorrectionTable from "../../Components/Services/ChangeOfCorrectionTable";
import ChangeOfAddressTable from "../../Components/Services/ChangeOfAddressTable";
import AnnualFeeModal from "../../Components/Applications/AnnualFeeModal";
import LostCertificateModal from "../../Components/Applications/LostCertificateModal";
import AnnualFeesModal from "../../Components/Applications/AnnualFeeModal";
import OtherServiceViewModel from "../../Components/Services/ViewModel";
import ViewRemarksModel from "../../Components/Applications/ViewRemarksModel";

import ServiceModel from "../../Components/Dashboard/ServiceModel";

const Associations = () => {
  const user = useSelector((state) => state.UserReducer.user);
  const gTypeOfGame = useSelector((state) => state?.GamesDataReducer?.games);

  const [openOtherServicesModel, setOpenOtherServicesModel] = useState(false);
      const [openViewRemarksModel, setOpenViewRemarksModel] = useState(false);
  
  const [openUploadModel, setOpenUploadModel] = useState(false);
  const [openViewModel, setOpenViewModel] = useState(false);
  const [otherServicesViewModel, setOpenOtherServicesViewModel] =
    useState(false);
  const [makePaymentModel, setMakePaymentModel] = useState(false);
  const [makeLCPaymentModel, setMakeLCPaymentModel] = useState(false);
  const [makeAFPaymentModel, setMakeAFPaymentModel] = useState(false);
  const [annualFeesModel, setAnnualFeesModel] = useState(false);
  const [annualFeesApiData, setAnnualFeesApiData] = useState(false);

  const [paymentApiData, setPaymentApiData] = useState(null);
  const [openDeleteModel, setOpenDeleteModel] = useState(false);
  const [openUpdateStatusModel, setOpenUpdateStatusModel] = useState(false);
  const [deviceId, setDeviceId] = useState("");
  const [selectedItem, setSelectedItem] = useState(null);
  const [openLostCertificateModel, setOpenLostCertificateModel] =
    useState(false);
  const [openFeeModel, setOpenFeeModel] = useState(false);

  const [searchType, setSearchType] = useState("0");
  const [serviceType, setServiceType] = useState("0");

  const [editDevice, setEditDevice] = useState(false);
  const { t, i18n } = useTranslation();

  const navigate = useNavigate();

  const { id } = useParams();

  const [startDate, setStartDate] = useState(
    moment(new Date()).subtract(60, "days").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    moment(new Date()).format("YYYY-MM-DD")
  );

  // // ----- Getting Initial Data ------
  const fetchFunction = async (values) => {
    const body = new FormData();
    body.append("token", user.id);
    body.append("userType", user.userType);
    body.append("startDate", startDate);
    body.append("endDate", endDate);
    body.append("status", values.status);
    body.append("serviceType", values.serviceType);
    return await axios.post(`${Config.apiUrl}/registeredassociations`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const getSuccess = (res) => {
    if (res.data.status == "NOK") error = true;
    if (res.data.status == "OK" && res.data.data == false) error = true;
  };

  const getError = (res) => {};

  const {
    isLoading,
    mutate: getAppRegMutate,
    error,
    data,
    refetch,
    isRefetching,
  } = useMutation(fetchFunction, {
    onSuccess: getSuccess,
    onError: getError,
  });

  useEffect(() => {
    let values = {
      status: "0",
      serviceType: "0",
    };

    getAppRegMutate(values);
  }, []);

  const initialValues = {
    startDate: moment(new Date()).subtract(60, "days").format("YYYY-MM-DD"),
    endDate: moment(new Date()).format("YYYY-MM-DD"),
  };

  const submitHandler = (values) => {
    const newValues = {
      startDate: moment(values.startDate).format("YYYY-MM-DD"),
      endDate: moment(values.endDate).format("YYYY-MM-DD"),
    };
    setStartDate(newValues.startDate);
    setEndDate(newValues.endDate);
    let filter = {
      status: searchType,
      serviceType: serviceType,
    };
    //getAppRegMutate(filter);
  };

  const searchHandler = (value) => {
    //setSearchType(value)
    let values = {
      status: value,
      serviceType: serviceType,
    };
    getAppRegMutate(values);
  };

  const serviceHandler = (value) => {
    //setServiceType(value)
    let values = {
      status: searchType,
      serviceType: value,
    };
    getAppRegMutate(values);
  };

  //------- Add Single Entry -------
  const SingleEntryPostFunction = async (values) =>
    await axios.post(
      `${Config.nodeApiUrl}/addSingleContact`,
      values,
      Config.AxiosConfig
    );

  const onSingleEntrySuccess = (res) => {
    refetch();
    setOpenUploadModel(false);
    toast.success(res?.data?.msg || "Success");
  };

  const onSingleEntryError = (res) => {
    setOpenUploadModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: SingleEntryLoading, mutate: postSingleEntry } =
    useMutation(SingleEntryPostFunction, {
      onSuccess: onSingleEntrySuccess,
      onError: onSingleEntryError,
    });

  //-------LostCertificatePostFunction-------
  const LostCertificatePostFunction = async (values) => {
    const body = new FormData();
    body.append("customerId", user.id);
    body.append("email", user.email);
    body.append("userType", user.userType);
    body.append("assocName", values.assocName);
    body.append("assocId", values.assocId);
    body.append("remarks", values.remarks);
    body.append("certificate", values.fileName);
    return await axios.post(`${Config.apiUrl}/lostcertificate`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onLostCertificateSuccess = (res) => {
    setOpenLostCertificateModel(false);
    toast.success(res?.data?.msg || "Success");
    //refetch();
  };

  const onLostCertificateError = (res) => {
    setOpenLostCertificateModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const {
    isLoading: UploadLostCertificateLoading,
    mutate: postLostCertificateMutate,
  } = useMutation(LostCertificatePostFunction, {
    onSuccess: onLostCertificateSuccess,
    onError: onLostCertificateError,
  });

  const LCPaymentDetailPostFunction = async (values) => {
    const body = new FormData();
    body.append("userType", user.userType);
    body.append("assocId", values.id);
    body.append("serviceType", 5);
    return await axios.post(`${Config.apiUrl}/getpaymentdetails`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onLCMakePaymentSuccess = (res) => {
    //setOpenUploadModel(false);
    if (res?.data?.status == "OK") {
      setPaymentApiData(res?.data.list);
      setMakeLCPaymentModel(true);
    } else {
      toast.error(res?.data?.msg || "An Error Occured");
    }
    //toast.success(res?.data?.msg || "Success");
  };

  const onLCMakePaymentError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.data?.msg || "An Error Occured");
  };

  const { isLoading: LCPaymentLoading, mutate: setMakeLCPaymentMutate } =
    useMutation(LCPaymentDetailPostFunction, {
      onSuccess: onLCMakePaymentSuccess,
      onError: onLCMakePaymentError,
    });

  const AFPaymentDetailPostFunction = async (values) => {
    const body = new FormData();
    body.append("userType", user.userType);
    body.append("assocId", values.id);
    body.append("serviceType", 6);
    return await axios.post(`${Config.apiUrl}/getpaymentdetails`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAFMakePaymentSuccess = (res) => {
    //setOpenUploadModel(false);
    if (res?.data?.status == "OK") {
      setPaymentApiData(res?.data.list);
      setMakeAFPaymentModel(true);
    } else {
      toast.error(res?.data?.msg || "An Error Occured");
    }
  };

  const onAFMakePaymentError = (res) => {
    //setOpenUploadModel(false);
    toast.error(res?.data?.msg || "An Error Occured");
  };

  const { isLoading: AFPaymentLoading, mutate: setMakeAFPaymentMutate } =
    useMutation(AFPaymentDetailPostFunction, {
      onSuccess: onAFMakePaymentSuccess,
      onError: onAFMakePaymentError,
    });

  const generateCNoApi = async (values) => {
    const body = new FormData();
    body.append("assocId", values.id);
    body.append("assocName", values.assocName);
    body.append("userType", user.userType);

    return await axios.post(`${Config.apiUrl}/annualfees`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onGenerateCNoSuccess = (res) => {
    if (res?.data?.status == "OK") {
      setOpenFeeModel(false);
      toast.success(res?.data?.msg || "Success");
      //refetch();
    }
  };

  const onGenerateCNoError = (res) => {
    setOpenFeeModel(false);
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: GenerateCNoLoading, mutate: generateCNoMutate } =
    useMutation(generateCNoApi, {
      onSuccess: onGenerateCNoSuccess,
      onError: onGenerateCNoError,
    });

  const annualFeesDetailsPostFunction = async (values) => {
    const body = new FormData();
    body.append("assocId", values.id);
    body.append("userType", user.userType);

    return await axios.post(`${Config.apiUrl}/getannualfeesdetails`, body, {
      headers: {
        authorization: user.token,
        "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
      },
    });
  };

  const onAFDetailsSuccess = (res) => {
    if (res?.data?.status == "OK") {
      setAnnualFeesApiData(res?.data?.list);
    } else toast.error(res?.data?.msg || "Error");
  };

  const onAFDetailsError = (res) => {
    toast.error(res?.response?.data?.msg || "An Error Occured");
  };

  const { isLoading: annualFeesLoading, mutate: annualFeesDetailsPostMutate } =
    useMutation(annualFeesDetailsPostFunction, {
      onSuccess: onAFDetailsSuccess,
      onError: onAFDetailsError,
    });

  return (
    <>
      <Navbar />
      <Page>
        {/* {makePaymentModel && (
          <PaymentModal 
          openMakePaymentModel={setMakePaymentModel}
          selectedItem={selectedItem}
          paymentApiData={paymentApiData}
           />
        )} */}
        {makeLCPaymentModel && (
          <LCPaymentModal
            openMakePaymentModel={setMakeLCPaymentModel}
            selectedItem={selectedItem}
            paymentApiData={paymentApiData}
          />
        )}
        {makeAFPaymentModel && (
          <LCPaymentModal
            openMakePaymentModel={setMakeAFPaymentModel}
            selectedItem={selectedItem}
            paymentApiData={paymentApiData}
          />
        )}

        {/* {openFeeModel && (
          <AnnualFeeModal setOpenFeeModel={setOpenFeeModel}
          selectedItem={selectedItem}
          />
        )} */}
        {openFeeModel && (
          <AnnualFeesModal
            setAnnualFeesModel={setOpenFeeModel}
            selectedItem={selectedItem}
            apiData={annualFeesApiData}
            GenerateCNoLoading={GenerateCNoLoading}
            generateCNoMutate={generateCNoMutate}
          />
        )}

        {openLostCertificateModel && (
          <LostCertificateModal
            setOpenLostCertificateModel={setOpenLostCertificateModel}
            uploadLostCertificateLoading={UploadLostCertificateLoading}
            postLostCertificateMutate={postLostCertificateMutate}
            selectedItem={selectedItem}
          />
        )}

        <BoxContainer>
          <div className="flex w-full justify-between items-center">
            <div>
              <Title>{t("My_Association")}</Title>
              <Underline />
            </div>

            {/* <Uploader setOpenUploadModel={setOpenUploadModel} /> */}
          </div>

          {openUploadModel && (
            <SingleEntry
              postSingleEntry={postSingleEntry}
              SingleEntryLoading={SingleEntryLoading}
              setOpenUploadModel={setOpenUploadModel}
              groupId={id}
            />
          )}
          {openViewModel && (
            <ViewModel
              setOpenViewModel={setOpenViewModel}
              selectedItem={selectedItem}
              gTypeOfGame={gTypeOfGame}
            />
          )}
{openViewRemarksModel && (
            <ViewRemarksModel
              setOpenViewRemarksModel={setOpenViewRemarksModel}
              selectedItem={selectedItem}
            />
          )}
          {openOtherServicesModel && (
            <ServiceModel
              setOpenOtherServicesModel={setOpenOtherServicesModel}
              data={data?.data}
              selectedItem={selectedItem}
            />
          )}

          {otherServicesViewModel && (
            <OtherServiceViewModel
              setOpenViewModel={setOpenOtherServicesViewModel}
              selectedItem={selectedItem}
              serviceType={serviceType}
            />
          )}

          {!isLoading && !isRefetching && (
            <TableWrapper>
              {serviceType == 0 && (
                <Table
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  setOpenDeleteModel={setOpenDeleteModel}
                  setSelectedItem={setSelectedItem}
                  setOpenUpdateStatusModel={setOpenUpdateStatusModel}
                  setOpenViewModel={setOpenViewModel}
                  makePaymentModel={setMakePaymentModel}
                  makeLCPaymentMutate={setMakeLCPaymentMutate}
                  makeAFPaymentMutate={setMakeAFPaymentMutate}
                  annualFeesDetailsPostMutate={annualFeesDetailsPostMutate}
                  setOpenLostCertificateModel={setOpenLostCertificateModel}
                  setOpenFeeModel={setOpenFeeModel}
                  setOpenOtherServicesModel={setOpenOtherServicesModel}
                setOpenViewRemarksModel={setOpenViewRemarksModel}

                />
              )}

              {serviceType == 1 && (
                <ChangeOfCorrectionTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  makePaymentModel={setMakePaymentModel}
                />
              )}

              {serviceType == 2 && (
                <ChangeOfArticleTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  makePaymentModel={setMakePaymentModel}
                />
              )}
              {serviceType == 3 && (
                <ChangeOfNameTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  makePaymentModel={setMakePaymentModel}
                />
              )}

              {serviceType == 4 && (
                <ChangeOfAddressTable
                  ApiData={
                    error || data?.data.data == false ? [] : data?.data.data
                  }
                  // setOpenDeleteModel={setOpenDeleteModel}
                  setUpdateStatusModel={setOpenUpdateStatusModel}
                  setSelectedItem={setSelectedItem}
                  // setOpenEditModel={setOpenEditModel}
                  setOpenViewModel={setOpenOtherServicesViewModel}
                  makePaymentModel={setMakePaymentModel}
                />
              )}
            </TableWrapper>
          )}

          {(isLoading || isRefetching) && <Loading />}
          {error && !isLoading && !isRefetching && <NotFoundModel />}
        </BoxContainer>
      </Page>
    </>
  );
};

const Filters = ({ initialValues, submitHandler, InitialLoading, user }) => {
  return (
    <Formik initialValues={initialValues} onSubmit={submitHandler}>
      <Form>
        <FilterContainer>
          <InputGroup className="max-w-xs">
            <Label htmlFor="startDate">Start Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="startDate" id="startDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <InputGroup className="max-w-xs">
            <Label htmlFor="endDate">End Date:</Label>
            <FieldWrapper className="h-10">
              <img
                src={Images.Calender}
                alt="Calender icon"
                className="w-3.5"
              />
              <Field type="date" name="endDate" id="endDate" class="ml-1" />
            </FieldWrapper>
          </InputGroup>

          <ApplyBtn disabled={InitialLoading} type="submit">
            Apply Date Filter
          </ApplyBtn>
        </FilterContainer>
      </Form>
    </Formik>
  );
};

const Uploader = ({ setOpenUploadModel }) => {
  return (
    <UploadWrapper>
      <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <MdAdd className="text-white w-5 h-5" /> <p>Run Campaign</p>
      </Button>
      {/* <Button type="button" onClick={() => setOpenUploadModel(true)}>
        <HiUpload className="text-white w-5 h-5" /> <p>Upload Bulk Contact</p>
      </Button> */}
    </UploadWrapper>
  );
};

const TableWrapper = tw.h1`my-10 border   rounded-md overflow-auto`;

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap   font-medium`;

const UploadWrapper = tw.div`
 w-full flex justify-end space-x-4 items-center `;

const Button = tw.button`text-white bg-teal-500 hover:bg-teal-600 w-40 flex items-center space-x-1 justify-center h-10   text-xs whitespace-nowrap rounded`;

const FilterContainer = tw.div`
grid grid-cols-2 w-full max-w-xl gap-4 md:flex md:space-x-4 items-end mt-12 md:mt-8`;

const ApplyBtn = tw.button`${(p) =>
  p.$active
    ? "bg-gray-100"
    : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-cyan-600 hover:bg-cyan-700  py-2.5 text-sm`;

export default Associations;
